<template>
  <v-container>
    <v-row class="text-center">
      <v-col cols="12">
        <v-img
          :src="require('../assets/logo.png')"
          class="my-3"
          contain
          height="200"
        />
      </v-col>

      <v-col class="mb-4">
        <h1 class="display-2 font-weight-bold mb-3">
          Welcome to Nexx360 Ad Impact Tool
        </h1>
      </v-col>
      
    </v-row>
    <v-row class="text-center">
      <v-col cols="12">
        <router-view/>
      </v-col>
    </v-row>
    
  </v-container>
</template>

<script>
  export default {
    name: 'HomeComponent',
    data: () => ({
      state: 'uploader',
      results: {},
    }),
    methods: {
      showResults(results) {
        this.results=results;
        this.state = 'results';
      }
    }
  }
</script>
